import { Component, OnInit, Input } from '@angular/core';
import { MatDialog } from '@angular/material';
import { CondicoesVoucherModalComponent } from '../modals/condicoes-voucher-modal/condicoes-voucher-modal.component';
import { GlobalService } from '../services/global.service';

declare const $: any;

@Component({
  selector: 'app-voucher',
  templateUrl: './voucher.component.html',
  styleUrls: ['./voucher.component.scss']
})
export class VoucherComponent implements OnInit {
  @Input() voucher: any;
  @Input() slim = false;
  @Input() condicoes = false;

  integrador = false;

  constructor(
    private dialog: MatDialog,
    private gloabalService: GlobalService
  ) { }

  async ngOnInit() {
    this.integrador = await this.gloabalService.integrador();
  }

  abrirModalCondicoes() {
    const largura = Number($('body').width());

    const dialogRef = this.dialog.open(CondicoesVoucherModalComponent, {
      width: largura > 550 ? '570px' : $('body').width().toString() + 'px',
      data: { voucher: this.voucher },
      panelClass: 'modal-card',
    });

    dialogRef.afterClosed().subscribe(() => { });
  }
}
